import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Card, Modal } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { Link } from 'react-router-dom'
import { FileStack } from 'lucide-react'
import { useAuth } from '../components/auth/useAuth'
import { useDispatch, useSelector } from "react-redux"
import { AppDispatch } from '../store'
import { getAllReports } from '../actions/other/sucursalsActions'

export default function Reports() {
    const { t } = useTranslation()
    const { clientauth } = useAuth()
    const dispatch: AppDispatch = useDispatch()
    const [modalShowIframe, setModalShowIframe] = useState(false)
    const [selectedReport, setSelectedReport] = useState<any>(null)
    const { informes, loading } = useSelector((state: any) => state.sucursals)

    useEffect(() => {
        if (clientauth?.idSucursal) {
            dispatch(getAllReports(clientauth.idSucursal) as any)
        }
    }, [dispatch, clientauth])

    return (
        <Container fluid className='p-1 py-5 p-md-5'>

            {!clientauth?.isAdmin

                ?

                <h1>{t("reportTranslate.accessdenied")}</h1>

                :

                <>
                    <Row>
                        <Col xs={12} >
                            <h1>{t("reportTranslate.reports")}</h1>
                        </Col>
                    </Row>

                    <Row>
                        {loading
                            ?
                            <p>{t("reportTranslate.loading")}</p>
                            :
                            informes.length > 0
                                ?
                                informes?.map((report: any) => (
                                    <Col xs={6} lg={3} className='my-3' key={report.id}>
                                        <Card className='dashboard' style={{ cursor: "pointer" }} onClick={() => {
                                            setSelectedReport(report)
                                            setModalShowIframe(true)
                                        }}>
                                            <Card.Body className='text-center p-4'>
                                                <FileStack size={48} className="m-2" />
                                                <h4>{report.titulo}</h4>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                ))
                                :
                                <p>{t("reportTranslate.thereisnotreport")}</p>

                        }
                    </Row>
                </>
            }


            <Modal
                show={modalShowIframe}
                onHide={() => setModalShowIframe(false)}
                fullscreen
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter-clip">
                        <h2 className='m-0'>{selectedReport?.titulo}</h2>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedReport?.iframe ? <div
                        className='iframe-container'
                        dangerouslySetInnerHTML={{ __html: selectedReport.iframe }}
                    /> : <p>No se ha cargado el informe</p>}
                </Modal.Body>
            </Modal>
        </Container>
    )
}